<template>
  <div>
    <Header title="Consultar Alocação" content-aligned />

    <div class="ml-md-8">
      <p
        @click="back"
        class="d-table c-blue font-weight-bold cursor-pointer pl-6"
      >
        <span
          ><v-icon class="c-blue">mdi-arrow-left-thin</v-icon></span
        >
        voltar
      </p>

      <Loading v-if="loading_data" />

      <div v-else-if="error">
        <NotFound
          type="404"
          title="Plano não encontrado"
          text="Verifique se você possui autorização para acessar este plano."
        />
      </div>

      <div v-else class="">
        <HandlePlanMenu
          v-if="tab != 3 && !demoMode"
          class="pr-8"
          :share="this.share"
          :hash="this.hash"
          :tab="tab"
          @action1="() => (tab = 1)"
          @action2="() => (tab = 2)"
          @share="handleShare"
          @history="() => (tab = 3)"
          @edit="() => (tab = 4)"
        />

        <div class="pa-5"></div>

        <PaasSolution
          v-if="tab === 0"
          :status="data.solution.status"
          :plan="data.solution"
        />

        <HandleEditInSimulator v-else-if="tab == 1" :plan="data" />

        <HandlePublicPlan
          v-else-if="tab == 2"
          :plan="data.solution"
        />

        <HandleHistory
          ref="handleHistoryComponent"
          v-else-if="tab === 3"
          :option="1"
          :plan="id"
          no-back
          @back="() => (tab = 0)"
        />

        <EditSolution
          ref="handleEditComponent"
          v-if="tab === 4"
          :solution="data.solution"
          :back="() => (tab = 0)"
          :save="handleEditSolution"
          no-back
          :option="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getPaasPlanSolution,
  toggleShare,
  editSolutionPlan
} from "@/api/paas/plans";

import Header from "@/components/Header.vue";
import Loading from "@/components/Loading.vue";
import PaasSolution from "@/components/paas/PaasSolution.vue";
import HandlePlanMenu from "@/handles/paas/plan/HandlePlanMenu.vue";
import HandleEditInSimulator from "@/handles/paas/plan/HandleEditInSimulator.vue";
import HandlePublicPlan from "@/handles/paas/plan/HandlePublicPlan.vue";
import NotFound from "@/components/NotFound.vue";
import HandleHistory from "@/handles/paas/history/HandleHistory.vue";
import EditSolution from "@/components/paas/EditSolution.vue";
import { getPaasPlanDemo } from "@/fixtures/paasPlansDemo";

export default {
  name: "PlanSolution",
  components: {
    Header,
    Loading,
    PaasSolution,
    HandlePlanMenu,
    HandleEditInSimulator,
    HandlePublicPlan,
    NotFound,
    HandleHistory,
    EditSolution
  },
  data() {
    return {
      id: null,
      loading_data: false,
      error: false,
      data: null,
      share: false,
      hash: undefined,
      tab: 0 // 0 -> solution, 1 -> edit in simulator, 2 -> public plan, 3 -> history
    };
  },
  computed: {
    demoMode() {
      return this.$route.query.demo == "1";
    }
  },
  mounted() {
    this.id = Number(this.$route.params.id);

    if (this.demoMode) {
      this.data = getPaasPlanDemo(this.id);
      this.share = this.data.share != 0;
      this.hash = this.data.hash;
      return;
    }

    this.loading_data = true;
    getPaasPlanSolution(this.id)
      .then(_ => {
        this.data = _;
        this.share = _.share != 0;
        this.hash = _.hash;
      })
      .catch(() => {
        this.error = true;
      })
      .finally(() => {
        this.loading_data = false;
      });
  },
  methods: {
    back() {
      if (this.tab === 3)
        return this.$refs.handleHistoryComponent.back();
      if (this.tab === 4)
        return this.$refs.handleEditComponent.goBack();
      if (this.tab != 0) return (this.tab = 0);
      this.$router.back();
    },
    handleShare() {
      this.share = !this.share;
      toggleShare(this.id).catch(() => {
        alert("Erro ao mudar compartilhamento.");
        this.share = !this.share;
      });
    },
    handleEditSolution(rooms, classes) {
      editSolutionPlan(this.id, classes, rooms)
      .then(() => {
        this.$router.go();
      })
      .catch(() => {
        alert('Erro ao salvar alterações.')
      })
    }
  }
};
</script>

<style scoped>
.c-blue {
  color: #0088ff;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
